module.exports = __webpack_public_path__ + "img/gifts.9780ced5.png";